const config = {
    homePage: {
        meta: {
            en: {
                title: "EfsaneBahis | Sports Betting and Casino | Official EfsaneBahis",
                description: "Enjoy high-odds sports betting with EfsaneBahis. Earn cash rewards on every coupon you play. EfsaneBahis pays out.",
                keywords: "betting, live betting, betting site, live betting sites, betting sites, casino, poker, bingo, horse racing",
            },
            tr: {
                title: "EfsaneBahis | Spor Bahisleri ve Casino | EfsaneBahis Resmi",
                description: "EfsaneBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. EfsaneBahis ile oynadığın her kupona nakit para kazan. Efsanebahis Kazandırır.",
                keywords: "bahis, canlı bahis, bahis sitesi, canlı bahis siteleri, bahis siteleri, casino, poker, tombala, at yarışı",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    signUpPage: {
        meta: {
            en: {
                title: "EfsaneBahis | Sports Betting and Casino | Official EfsaneBahis",
                description: "Enjoy high-odds sports betting with EfsaneBahis. Earn cash rewards on every coupon you play. EfsaneBahis pays out.",
                keywords: "betting, live betting, betting site, live betting sites, betting sites, casino, poker, bingo, horse racing",
            },
            tr: {
                title: "EfsaneBahis | Spor Bahisleri ve Casino | EfsaneBahis Resmi",
                description: "EfsaneBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. EfsaneBahis ile oynadığın her kupona nakit para kazan. Efsanebahis Kazandırır.",
                keywords: "bahis, canlı bahis, bahis sitesi, canlı bahis siteleri, bahis siteleri, casino, poker, tombala, at yarışı",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    livePage: {
        meta: {
            en: {
                title: "EfsaneBahis | Sports Betting and Casino | Official EfsaneBahis",
                description: "Enjoy high-odds sports betting with EfsaneBahis. Earn cash rewards on every coupon you play. EfsaneBahis pays out.",
                keywords: "live betting, live betting site, best live betting, most trusted live betting",
            },
            tr: {
                title: "EfsaneBahis | Spor Bahisleri ve Casino | EfsaneBahis Resmi",
                description: "EfsaneBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. EfsaneBahis ile oynadığın her kupona nakit para kazan. Efsanebahis Kazandırır.",
                keywords: "canlı bahis, canlı bahis sitesi, en iyi canlı bahis, en güvenilir canlı bahis",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    sportPage: {
        meta: {
            en: {
                title: "EfsaneBahis | Sports Betting and Casino | Official EfsaneBahis",
                description: "Enjoy high-odds sports betting with EfsaneBahis. Earn cash rewards on every coupon you play. EfsaneBahis pays out.",
                keywords: "sports betting, sports bets, sports betting site, sports betting sites",
            },
            tr: {
                title: "EfsaneBahis | Spor Bahisleri ve Casino | EfsaneBahis Resmi",
                description: "EfsaneBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. EfsaneBahis ile oynadığın her kupona nakit para kazan. Efsanebahis Kazandırır.",
                keywords: "spor bahis, spor bahisleri, spor bahis sitesi, spor bahisleri sitesi",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    casinosPage: {
        meta: {
            en: {
                title: "EfsaneBahis | Sports Betting and Casino | Official EfsaneBahis",
                description: "Enjoy high-odds sports betting with EfsaneBahis. Earn cash rewards on every coupon you play. EfsaneBahis pays out.",
                keywords: "live casino, live roulette, live blackjack, live baccarat, live turkish roulette, live holdem",
            },
            tr: {
                title: "EfsaneBahis | Spor Bahisleri ve Casino | EfsaneBahis Resmi",
                description: "EfsaneBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. EfsaneBahis ile oynadığın her kupona nakit para kazan. Efsanebahis Kazandırır.",
                keywords: "canlı casino, canlı rulet, canlı blackjeack, canlı baccarat, canlı türk ruleti, canlı holdem",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    slotsPage: {
        meta: {
            en: {
                title: "EfsaneBahis | Sports Betting and Casino | Official EfsaneBahis",
                description: "Enjoy high-odds sports betting with EfsaneBahis. Earn cash rewards on every coupon you play. EfsaneBahis pays out.",
                keywords: "slot, play slots, slot games, live slots",
            },
            tr: {
                title: "EfsaneBahis | Spor Bahisleri ve Casino | EfsaneBahis Resmi",
                description: "EfsaneBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. EfsaneBahis ile oynadığın her kupona nakit para kazan. Efsanebahis Kazandırır.",
                keywords: "slot, slot oyna, slot oyunları, canlı slot",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    slotsBattlePage: {
        meta: {
            en: {
                title: "Slot Battle",
                description: "Slot Battle, first in Turkey",
                keywords: "",
            },
            tr: {
                title: "Slot Battle",
                description: "Slot Battle Türkiye'de ilk",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    liveCasinoPage: {
        meta: {
            en: {
                title: "Live Slot",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Canlı Slot",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    forgotPassword: {
        meta: {
            en: {
                title: "Forgot Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifremi unuttum",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    resetPassword: {
        meta: {
            en: {
                title: "Reset Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifre yenileme",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    changePassword: {
        meta: {
            en: {
                title: "Change Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifre Değiştir",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    promoPage: {
        meta: {
            en: {
                title: "EfsaneBahis | Sports Betting and Casino | Official EfsaneBahis",
                description: "Enjoy high-odds sports betting with EfsaneBahis. Earn cash rewards on every coupon you play. EfsaneBahis pays out.",
                keywords: "bonus, betting bonuses, casino bonuses, bonus sites",
            },
            tr: {
                title: "EfsaneBahis | Spor Bahisleri ve Casino | EfsaneBahis Resmi",
                description: "EfsaneBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. EfsaneBahis ile oynadığın her kupona nakit para kazan. Efsanebahis Kazandırır.",
                keywords: "bonus, bahis bonusları, casno bonusları, bonus veren siteler",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    aboutUsPage: {
        meta: {
            en: {
                title: "About Us",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Hakkımızda",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    myAccountPage: {
        meta: {
            en: {
                title: "My Account",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Hesabım",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    betOnGames: {
        meta: {
            en: {
                title: "EfsaneBahis | Sports Betting and Casino | Official EfsaneBahis",
                description: "Enjoy high-odds sports betting with EfsaneBahis. Earn cash rewards on every coupon you play. EfsaneBahis pays out.",
                keywords: "slot, play slots, slot games, live slots",
            },
            tr: {
                title: "EfsaneBahis | Spor Bahisleri ve Casino | EfsaneBahis Resmi",
                description: "EfsaneBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. EfsaneBahis ile oynadığın her kupona nakit para kazan. Efsanebahis Kazandırır.",
                keywords: "slot, slot oyna, slot oyunları, canlı slot",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    twain: {
        meta: {
            en: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            tr: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    liveGames: {
        meta: {
            en: {
                title: "Bingo | EfsaneBahis",
                description: "Join EfsaneBahis, the best bingo site with the widest live bingo variety, and win at bingo!",
                keywords: "bingo, live bingo, bingo games, play bingo",
            },
            tr: {
                title: "Tombala | EfsaneBahis",
                description: "Canlı tombala alanında en çok tombala oyun çeşiti ile en iyi tombala sitesi olan EfsaneBahis'ya gelin, tombala oyunlarında kazanın!",
                keywords: "tombala, canlı tombala, tombala oyunları, tombala oyna",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    lottery: {
        meta: {
            en: {
                title: "EfsaneBahis | Sports Betting and Casino | Official EfsaneBahis",
                description: "Enjoy high-odds sports betting with EfsaneBahis. Earn cash rewards on every coupon you play. EfsaneBahis pays out.",
                keywords: "lottery, play lottery",
            },
            tr: {
                title: "EfsaneBahis | Spor Bahisleri ve Casino | EfsaneBahis Resmi",
                description: "EfsaneBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. EfsaneBahis ile oynadığın her kupona nakit para kazan. Efsanebahis Kazandırır.",
                keywords: "loto, loto oyna",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    tvbet: {
        meta: {
            en: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            tr: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    helpPage: {
        meta: {
            en: {
                title: "Contact Us",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Bize Ulaşın",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    mailVerify: {
        meta: {
            en: {
                title: "Email Verification",
                description: "",
                keywords: " ",
            },
            tr: {
                title: "E-Posta doğrulama",
                description: " ",
                keywords: " ",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    lobbyPage: {
        meta: {
            en: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
};

export default config;
